import React from "react";
import "../../Components/Menu/Menu.css";

export default function Collection() {
  return (
    <div>
      <h4 className="sub-title">
        Innhenting av data og deling med tredjeparter
      </h4>
      <p className="content">
        <ul>
          <li>
            Generelt om partnere og deling av data: Når du tar i bruk ulike
            tjenester levert av andre tjenestetilbydere inne i appen, vil vi be
            deg om samtykke til deling av data mellom tjenestetilbyderen og
            Bilista.
          </li>
          <li>
            Autosys: Statens vegvesen har et register over alle biler i Norge.
            Fra dette registeret henter vi informasjon om bilene du er
            registrert som eier av, slik at vi kan vise en oversikt over bilene
            dine og knytte dem til levering av tjenester i appen.
          </li>
        </ul>
      </p>
    </div>
  );
}
